export const QUOTATION_DESCRIPTION_MIN_LENGTHApi = 30;
export const QUOTATION_DESCRIPTION_MAX_LENGTHApi = 1500;
export const QUOTATION_TITLE_MAX_LENGTHApi = 50;
export var QuotationContextTypeApi;
(function (QuotationContextTypeApi) {
    QuotationContextTypeApi["PROJECT"] = "project";
    QuotationContextTypeApi["BID"] = "bid";
    QuotationContextTypeApi["THREAD"] = "thread";
    QuotationContextTypeApi["USER"] = "user";
    QuotationContextTypeApi["EXTERNAL"] = "external";
    QuotationContextTypeApi["TEMPLATE"] = "template";
})(QuotationContextTypeApi || (QuotationContextTypeApi = {}));
export var QuotationExceptionCodesApi;
(function (QuotationExceptionCodesApi) {
    QuotationExceptionCodesApi["QUOTATION_CURRENCY_NOT_FOUND"] = "quotation_currency_not_found";
    QuotationExceptionCodesApi["QUOTATION_PROJECT_INACTIVE"] = "quotation_project_inactive";
    QuotationExceptionCodesApi["QUOTATION_PROJECT_NOT_FOUND"] = "quotation_project_not_found";
    QuotationExceptionCodesApi["QUOTATION_BID_RETRACTED"] = "quotation_bid_retracted";
    QuotationExceptionCodesApi["QUOTATION_NOT_DRAFT"] = "quotation_not_draft";
    QuotationExceptionCodesApi["QUOTATION_NOT_FOUND"] = "quotation_not_found";
    QuotationExceptionCodesApi["QUOTATION_ITEM_NOT_FOUND"] = "quotation_item_not_found";
    QuotationExceptionCodesApi["QUOTATION_ITEM_ALREADY_DELETED"] = "quotation_item_already_deleted";
    QuotationExceptionCodesApi["QUOTATION_WRONG_DRAFT_VERSION"] = "quotation_wrong_draft_version";
    QuotationExceptionCodesApi["QUOTATION_ITEM_IDS_INCONSISTENT"] = "quotation_item_ids_inconsistent";
    QuotationExceptionCodesApi["QUOTATION_ITEM_CLOSED"] = "quotation_item_closed";
    QuotationExceptionCodesApi["QUOTATION_ITEM_MUTABLE"] = "quotation_item_mutable";
    QuotationExceptionCodesApi["QUOTATION_UPDATE_ACCEPTING_AND_REJECTING"] = "quotation_update_accepting_and_rejecting";
    QuotationExceptionCodesApi["QUOTATION_IS_INVALID"] = "quotation_is_invalid";
    QuotationExceptionCodesApi["QUOTATION_VERSION_IS_INVALID"] = "quotation_version_is_invalid";
    QuotationExceptionCodesApi["QUOTATION_VERSION_INCONSISTENT"] = "quotation_version_inconsistent";
    QuotationExceptionCodesApi["QUOTATION_ID_CONFLICT"] = "quotation_id_conflict";
    QuotationExceptionCodesApi["QUOTATION_DRAFT_EXISTS"] = "quotation_draft_exists";
    QuotationExceptionCodesApi["QUOTATION_MULTIPLE_DRAFTS_EXIST"] = "quotation_multiple_drafts_exist";
    QuotationExceptionCodesApi["QUOTATION_BID_NOT_FOUND"] = "quotation_bid_not_found";
    QuotationExceptionCodesApi["QUOTATION_FUND_INSUFFICIENT"] = "quotation_fund_insufficient";
    QuotationExceptionCodesApi["QUOTATION_ITEM_AMOUNT_TOO_LOW"] = "quotation_item_amount_too_low";
    QuotationExceptionCodesApi["QUOTATION_NOT_APPROVED"] = "quotation_not_approved";
    QuotationExceptionCodesApi["QUOTATION_INCORRECT_CONTEXT"] = "quotation_incorrect_context";
    QuotationExceptionCodesApi["QUOTATION_UPFRONT_FUNDING_AMOUNT_TOO_HIGH"] = "quotation_upfront_funding_amount_too_high";
    QuotationExceptionCodesApi["QUOTATION_THREAD_NOT_FOUND"] = "quotation_thread_not_found";
    QuotationExceptionCodesApi["QUOTATION_THREAD_TYPE_INVALID"] = "quotation_thread_type_invalid";
    QuotationExceptionCodesApi["QUOTATION_THREAD_CONTEXT_NOT_ASSIGNABLE"] = "quotation_thread_context_not_assignable";
    QuotationExceptionCodesApi["QUOTATION_THREAD_NOT_EDITABLE"] = "quotation_thread_not_editable";
    QuotationExceptionCodesApi["QUOTATION_CONTEXT_TYPE_INVALID"] = "quotation_context_type_invalid";
    QuotationExceptionCodesApi["QUOTATION_EXPIRED"] = "quotation_expired";
    QuotationExceptionCodesApi["QUOTATION_CANCELLED"] = "quotation_cancelled";
    QuotationExceptionCodesApi["QUOTATION_REJECTED"] = "quotation_rejected";
    QuotationExceptionCodesApi["HIREME_QUOTATION_INVALID"] = "hireme_quotation_invalid";
    QuotationExceptionCodesApi["QUOTATION_APPROVED"] = "quotation_approved";
    QuotationExceptionCodesApi["QUOTATION_AMOUNT_BELOW_MINIMUM_BUDGET"] = "quotation_amount_below_minimum_budget";
    QuotationExceptionCodesApi["QUOTATION_LIMIT_REACHED"] = "quotation_limit_reached";
    QuotationExceptionCodesApi["QUOTATION_EXPIRY_DATE_CANNOT_BE_IN_PAST"] = "quotation_expiry_date_cannot_be_in_past";
    QuotationExceptionCodesApi["PROJECT_QUOTATION_LIMIT_REACHED"] = "project_quotation_limit_reached";
    QuotationExceptionCodesApi["QUOTATION_CONTEXT_NOT_ASSIGNABLE"] = "quotation_context_not_assignable";
    QuotationExceptionCodesApi["QUOTATION_DURATION_NOT_ASSIGNABLE"] = "quotation_duration_not_assignable";
    QuotationExceptionCodesApi["QUOTATION_INVALID_STATUS"] = "quotation_invalid_status";
    QuotationExceptionCodesApi["QUOTATION_PARENT_TEMPLATE_NOT_FOUND"] = "quotation_parent_template_not_found";
    QuotationExceptionCodesApi["CHILD_QUOTATION_MORE_THAN_ONE_PENDING"] = "child_quotation_more_than_one_pending";
    QuotationExceptionCodesApi["QUOTATION_MISUSING_HELPER_FUNCTIONS"] = "quotation_misusing_helper_functions";
    QuotationExceptionCodesApi["QUOTATION_LOGO_NOT_FOUND"] = "quotation_logo_not_found";
    QuotationExceptionCodesApi["QUOTATION_LOGO_CANNOT_BE_UPDATED"] = "quotation_logo_cannot_be_updated";
    QuotationExceptionCodesApi["QUOTATION_LOGO_CREATOR_MISMATCH"] = "quotation_logo_creator_mismatch";
    QuotationExceptionCodesApi["QUOTATION_ONLY_ONE_HOURLY_ITEM_ALLOWED"] = "quotation_only_one_hourly_item_allowed";
    QuotationExceptionCodesApi["QUOTATION_ITEM_INVALID_BILLING_FREQUENCY"] = "quotation_item_invalid_billing_frequency";
})(QuotationExceptionCodesApi || (QuotationExceptionCodesApi = {}));
export var QuotationStatusApi;
(function (QuotationStatusApi) {
    QuotationStatusApi["DRAFT"] = "draft";
    QuotationStatusApi["PENDING"] = "pending";
    QuotationStatusApi["INVALID"] = "invalid";
    QuotationStatusApi["APPROVED"] = "approved";
    QuotationStatusApi["CANCELLED"] = "cancelled";
    QuotationStatusApi["REJECTED"] = "rejected";
    QuotationStatusApi["EXPIRED"] = "expired";
})(QuotationStatusApi || (QuotationStatusApi = {}));
export var QuotationItemStatusApi;
(function (QuotationItemStatusApi) {
    QuotationItemStatusApi["PENDING"] = "pending";
    QuotationItemStatusApi["COMPLETE"] = "complete";
    QuotationItemStatusApi["INVALID"] = "invalid";
})(QuotationItemStatusApi || (QuotationItemStatusApi = {}));
export var QuotationItemUnitTypeApi;
(function (QuotationItemUnitTypeApi) {
    QuotationItemUnitTypeApi["HOUR"] = "hour";
})(QuotationItemUnitTypeApi || (QuotationItemUnitTypeApi = {}));
export var QuotationFundTypeApi;
(function (QuotationFundTypeApi) {
    QuotationFundTypeApi["FUND"] = "fund";
    QuotationFundTypeApi["RELEASE"] = "release";
    QuotationFundTypeApi["INITIAL_FUND"] = "initial_fund";
})(QuotationFundTypeApi || (QuotationFundTypeApi = {}));
export var QuotationFundRequestStatusApi;
(function (QuotationFundRequestStatusApi) {
    QuotationFundRequestStatusApi["PENDING"] = "pending";
    QuotationFundRequestStatusApi["ACCEPTED"] = "accepted";
    QuotationFundRequestStatusApi["REJECTED"] = "rejected";
    QuotationFundRequestStatusApi["RETRACTED"] = "retracted";
})(QuotationFundRequestStatusApi || (QuotationFundRequestStatusApi = {}));
export var QuotationFundRequestActionApi;
(function (QuotationFundRequestActionApi) {
    QuotationFundRequestActionApi["REJECT"] = "reject";
    QuotationFundRequestActionApi["RETRACT"] = "retract";
    QuotationFundRequestActionApi["ACCEPT"] = "accept";
})(QuotationFundRequestActionApi || (QuotationFundRequestActionApi = {}));
export var SubscriptionItemStatusApi;
(function (SubscriptionItemStatusApi) {
    SubscriptionItemStatusApi["ACTIVE"] = "active";
    SubscriptionItemStatusApi["CANCELLED"] = "cancelled";
    SubscriptionItemStatusApi["PAUSED"] = "paused";
    SubscriptionItemStatusApi["AWAITING_PAYMENT"] = "awaiting_payment";
})(SubscriptionItemStatusApi || (SubscriptionItemStatusApi = {}));
export var ScheduledSubscriptionPaymentStatusApi;
(function (ScheduledSubscriptionPaymentStatusApi) {
    ScheduledSubscriptionPaymentStatusApi["PENDING"] = "pending";
    ScheduledSubscriptionPaymentStatusApi["SUCCESS"] = "success";
    ScheduledSubscriptionPaymentStatusApi["UNFUNDED"] = "unfunded";
    ScheduledSubscriptionPaymentStatusApi["FAILURE"] = "failure";
})(ScheduledSubscriptionPaymentStatusApi || (ScheduledSubscriptionPaymentStatusApi = {}));
export var QuotationItemBillingFrequencyApi;
(function (QuotationItemBillingFrequencyApi) {
    QuotationItemBillingFrequencyApi["MONTHLY"] = "monthly";
})(QuotationItemBillingFrequencyApi || (QuotationItemBillingFrequencyApi = {}));
